import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

const activityItems = [
  {
    time: '12:04 PM',
    description: 'Ava R. redeemed 20% Off Edibles',
  },
  {
    time: '11:52 AM',
    description: "Sent SMS campaign 'Weekend Special'",
  },
  {
    time: '10:37 AM',
    description: '112 geofence hits from Downtown Toronto',
  },
  {
    time: '09:21 AM',
    description: 'Added 37 new loyalty members',
  },
  {
    time: 'Yesterday',
    description: "Campaign '4/20 Promo' generated $4,750 in revenue",
  },
];

export function LiveActivityFeed() {
  return (
    <Card className='h-[320px] overflow-hidden shadow-none'>
      <CardHeader className='pb-2'>
        <CardTitle>What's Happening Now</CardTitle>
        <CardDescription className='text-md'>
          Real-time activity from your customers and campaigns
        </CardDescription>
      </CardHeader>
      <CardContent className='p-0'>
        <div className='h-[220px] overflow-y-auto px-4 sm:px-6 py-3 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent'>
          <div className='space-y-3'>
            {activityItems.map((item, index) => (
              <div key={index} className='flex items-start'>
                <div className='w-[60px] flex-shrink-0 text-[12px] text-muted-foreground mr-2'>
                  {item.time}
                </div>
                <div className='text-[12px] break-words overflow-hidden'>
                  {item.description}
                </div>
              </div>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
